import React, { ReactElement } from "react";
import { useHightlightStyles } from "./highlight.styles";
import { Grid, Typography } from "@material-ui/core";
import { format } from "date-fns-tz";
import { CalendarIcon } from "../../icons";
import { HighlightIcon } from "../../icons/Highlight.icon";

interface HighlightProps {
  title: string;
  description: string;
  date: Date;
  column: boolean;
  icon?: ReactElement;
  id?: string;
}

const Highlight = ({
  title,
  description,
  date,
  column,
  icon,
  id,
}: HighlightProps) => {
  const classes = useHightlightStyles();
  return (
    <Grid item md={column || 4} className={classes.highlightContainer} id={id}>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.highlightItem}
      >
        <Grid container direction="row">
          {icon ? icon : <HighlightIcon />}
          <div className={classes.textContainer}>
            <div className={classes.title}>
              <Typography>
                {title.length > 30 ? `${title.substring(0, 30)}...` : title}
              </Typography>
            </div>
            <Typography className={classes.description}>
              {description.length > 60
                ? `${description.substring(0, 60)}...`
                : description}
            </Typography>
          </div>
        </Grid>
        <div className={classes.date}>
          <CalendarIcon className={classes.icon} />
          <Typography>{format(date, "M/d/yyyy")}</Typography>
        </div>
      </Grid>
    </Grid>
  );
};

Highlight.defaultProps = {
  column: true,
};

export default Highlight;
